// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* News */
.newtab {
  display: flex;
  align-items: flex-end;
  text-align: left;
}

.newtab .nav-link {
  color: var(--primary_color) !important;
}

.newtitle {
  display: flex;
  font-size: 35pt;
  font-family: "Rufina", serif;
  font-weight: 500;
  height: 100%;
  align-items: flex-end;
  margin-bottom: 10px;
}

.newc {
  display: flex;
  align-items: flex-end;
  height: 100%;
}

.row .item {
  margin-top: 50px;
}

.row .tabcontent {
  margin-top: 50px;
  margin-bottom: 50px;
}

.pagectrl {
  border-top: 1px solid rgba(94, 94, 94, 0.9333333333);
}

.pagination {
  justify-content: center;
  margin-top: 30px;
}

.news li {
  list-style: none;
  font-size: 1.2rem;
}

.newbox {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
}

.newbox:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

/* 圖片固定比例，避免抖動 */
.newbox-imgwrap {
  width: 100%;
  aspect-ratio: 16/9; /* 需要較方可改成 4/3 或移除用固定高度 */
  overflow: hidden;
  background: #f4f4f4;
}

.newbox-imgwrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 內容區 */
.newmain {
  padding: 16px;
}

.newmain h2 {
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 8px;
  color: #222;
}

.newmain .newdate {
  display: block;
  font-size: 0.85rem;
  color: #888;
  margin-bottom: 10px;
}

.newmain p {
  font-size: 0.95rem;
  color: #555;
  margin: 0 0 12px;
}

/* Learn more 樣式 */
.newmain .lm {
  font-size: 0.85rem;
  color: #0d6efd; /* bootstrap primary */
  font-weight: 700;
  text-transform: uppercase;
}

/* 兩行截斷工具類（標題、簡介通用） */
.line-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 分類 tab 小調整 */
.newtab {
  margin: 12px 0 20px;
  gap: 6px;
  flex-wrap: wrap;
}

.newtab .nav-link {
  border: 1px solid #e5e5e5;
  color: #333;
}

.newtab .nav-link.active,
.newtab .nav-link:hover,
.sharetab .nav-link.active,
.sharetab .nav-link:hover {
  background: #0d6efd !important;
  color: #fff !important;
  border-color: #0d6efd !important;
}

/* 分頁按鈕 active 狀態 */
.page-link.active {
  background: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}

/* video */
@media (max-width: 900px) {
  .video-xl {
    display: none;
  }
}
@media (min-width: 900px) {
  .video-l {
    display: none;
  }
}
/* share */
.sharetab .nav-link {
  color: var(--primary_color) !important;
}

.sharecard .share-avatar {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  margin: 0 auto 1.5rem;
}

/* CPA 年份按鈕 */
.nav-pills .nav-link {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #333 !important;
  margin-right: 6px;
}

.nav-pills .nav-link.active,
.nav-pills .nav-link:hover {
  background: #0d6efd !important;
  color: #fff !important;
  border-color: #0d6efd !important;
}

/* ================================
   HOME REELS SECTION
================================ */
.home-reels-section {
  padding: 70px 0 90px;
  background: #f8f9fc;
}
.home-reels-section .home-reels-header {
  text-align: center;
  margin-bottom: 40px;
}
.home-reels-section .home-reels-header h2 {
  font-size: 32px;
  font-weight: 700;
  color: #152046;
  margin-bottom: 12px;
}
.home-reels-section .home-reels-header p {
  font-size: 16px;
  color: #666;
  margin: 0;
}
.home-reels-section .home-reels-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  max-width: 1150px;
  margin: 0 auto;
}
.home-reels-section .home-reels-item {
  min-width: 0;
  overflow: hidden;
}
.home-reels-section .home-reels-video {
  position: relative;
  width: 100%;
  aspect-ratio: 9/16;
  background: #000;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.home-reels-section .home-reels-video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.home-reels-section .home-reels-title {
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  color: #152046;
  margin-top: 15px;
  line-height: 1.5;
}

/* ================================
   TABLET
================================ */
@media (max-width: 991px) {
  .home-reels-section {
    padding: 55px 0 70px;
  }
  .home-reels-section .home-reels-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    max-width: 650px;
  }
  .home-reels-section .home-reels-header h2 {
    font-size: 28px;
  }
}
/* ================================
   MOBILE
================================ */
@media (max-width: 576px) {
  .home-reels-section {
    padding: 40px 0 55px;
  }
  .home-reels-section .home-reels-header {
    margin-bottom: 25px;
  }
  .home-reels-section .home-reels-header h2 {
    font-size: 24px;
  }
  .home-reels-section .home-reels-header p {
    font-size: 14px;
  }
  .home-reels-section .home-reels-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .home-reels-section .home-reels-video {
    border-radius: 10px;
  }
  .home-reels-section .home-reels-title {
    font-size: 13px;
    margin-top: 10px;
  }
}
/* ================================
   EXTRA SMALL MOBILE
================================ */
@media (max-width: 360px) {
  .home-reels-section .home-reels-grid {
    grid-template-columns: 1fr;
    max-width: 260px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/styles/home.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,SAAA;AACA;EACI,aAAA;EACA,qBAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,sCAAA;AAGJ;;AADA;EACI,aAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAIJ;;AAFA;EACI,aAAA;EACA,qBAAA;EACA,YAAA;AAKJ;;AAHA;EACI,gBAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,mBAAA;AAOJ;;AALA;EACI,oDAAA;AAQJ;;AANA;EACI,uBAAA;EACA,gBAAA;AASJ;;AALI;EACI,gBAAA;EACA,iBAAA;AAQR;;AALA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,qDAAA;EACA,YAAA;AAQF;;AALA;EACE,2BAAA;EACA,0CAAA;AAQF;;AALA,gBAAA;AACA;EACE,WAAA;EACA,kBAAA,EAAA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAQF;;AANA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AASF;;AANA,QAAA;AACA;EACE,aAAA;AASF;;AAPA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAUF;;AARA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAWF;;AATA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAYF;;AATA,kBAAA;AACA;EACE,kBAAA;EACA,cAAA,EAAA,sBAAA;EACA,gBAAA;EACA,yBAAA;AAYF;;AATA,qBAAA;AACA;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;AAYF;;AATA,eAAA;AACA;EACE,mBAAA;EACA,QAAA;EACA,eAAA;AAYF;;AAVA;EACE,yBAAA;EACA,WAAA;AAaF;;AAXA;;;;EAIE,8BAAA;EACA,sBAAA;EACA,gCAAA;AAcF;;AAXA,mBAAA;AACA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAcF;;AAZA,UAAA;AACA;EACI;IACI,aAAA;EAeN;AACF;AAbA;EACI;IACI,aAAA;EAeN;AACF;AAZA,UAAA;AACA;EACI,sCAAA;AAcJ;;AAXE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAcJ;;AATA,aAAA;AACA;EACE,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AAYF;;AATA;;EAEE,8BAAA;EACA,sBAAA;EACA,gCAAA;AAYF;;AATA;;kCAAA;AAIA;EACI,oBAAA;EACA,mBAAA;AAWJ;AATI;EACI,kBAAA;EACA,mBAAA;AAWR;AATQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAWZ;AARQ;EACI,eAAA;EACA,WAAA;EACA,SAAA;AAUZ;AANI;EACI,aAAA;EACA,gDAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAQR;AALI;EACI,YAAA;EACA,gBAAA;AAOR;AAJI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAMR;AAJQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAMZ;AAFI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAIR;;AACA;;kCAAA;AAIA;EAEI;IACI,oBAAA;EAAN;EAEM;IACI,gDAAA;IACA,SAAA;IACA,gBAAA;EAAV;EAGM;IACI,eAAA;EADV;AACF;AAOA;;kCAAA;AAIA;EAEI;IACI,oBAAA;EAPN;EASM;IACI,mBAAA;EAPV;EASU;IACI,eAAA;EAPd;EAUU;IACI,eAAA;EARd;EAYM;IACI,gDAAA;IACA,SAAA;EAVV;EAaM;IACI,mBAAA;EAXV;EAcM;IACI,eAAA;IACA,gBAAA;EAZV;AACF;AAkBA;;kCAAA;AAIA;EAIQ;IACI,0BAAA;IACA,gBAAA;EApBV;AACF","sourcesContent":["/* News */\n.newtab {\n    display: flex; \n    align-items: flex-end;\n    text-align: left;\n}\n.newtab .nav-link{\n    color: var(--primary_color) !important;\n}\n.newtitle {\n    display: flex;\n    font-size: 35pt;\n    font-family: 'Rufina', serif;\n    font-weight: 500;\n    height: 100%;\n    align-items: flex-end;\n    margin-bottom: 10px;\n}\n.newc{\n    display: flex;\n    align-items: flex-end;\n    height: 100%; \n}\n.row .item {\n    margin-top: 50px;\n}\n.row .tabcontent {\n    margin-top: 50px;\n    margin-bottom: 50px;\n}\n.pagectrl {\n    border-top: 1px solid #5e5e5eee;\n}\n.pagination {\n    justify-content: center;\n    margin-top: 30px;\n}\n.news {\n\n    li{\n        list-style: none;\n        font-size: 1.2rem;\n    }\n}\n.newbox {\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n  transition: transform .2s ease, box-shadow .2s ease;\n  height: 100%;\n}\n\n.newbox:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 20px rgba(0,0,0,0.12);\n}\n\n/* 圖片固定比例，避免抖動 */\n.newbox-imgwrap {\n  width: 100%;\n  aspect-ratio: 16 / 9; /* 需要較方可改成 4/3 或移除用固定高度 */\n  overflow: hidden;\n  background: #f4f4f4;\n}\n.newbox-imgwrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* 內容區 */\n.newmain {\n  padding: 16px;\n}\n.newmain h2 {\n  font-size: 1.05rem;\n  font-weight: 700;\n  margin: 0 0 8px;\n  color: #222;\n}\n.newmain .newdate {\n  display: block;\n  font-size: .85rem;\n  color: #888;\n  margin-bottom: 10px;\n}\n.newmain p {\n  font-size: .95rem;\n  color: #555;\n  margin: 0 0 12px;\n}\n\n/* Learn more 樣式 */\n.newmain .lm {\n  font-size: .85rem;\n  color: #0d6efd; /* bootstrap primary */\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n/* 兩行截斷工具類（標題、簡介通用） */\n.line-2 {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* 分類 tab 小調整 */\n.newtab {\n  margin: 12px 0 20px;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.newtab .nav-link {\n  border: 1px solid #e5e5e5;\n  color: #333;\n}\n.newtab .nav-link.active,\n.newtab .nav-link:hover,\n.sharetab .nav-link.active,\n.sharetab .nav-link:hover {\n  background: #0d6efd !important;\n  color: #fff !important;\n  border-color: #0d6efd !important;\n}\n\n/* 分頁按鈕 active 狀態 */\n.page-link.active {\n  background: #0d6efd;\n  color: #fff;\n  border-color: #0d6efd;\n}\n/* video */\n@media (max-width:900px) {\n    .video-xl {\n        display: none;\n    }\n}\n@media (min-width:900px) {\n    .video-l {\n        display: none;\n    }\n}\n\n/* share */\n.sharetab .nav-link{\n    color: var(--primary_color) !important;\n}\n.sharecard {\n  .share-avatar {\n    width: 200px;      // 圓形大小可以自己調\n    height: 200px;\n    border-radius: 50%; // 關鍵：變圓\n    object-fit: cover;  // 讓長方形照片裁成圓不會變形\n    display: block;\n    margin: 0 auto 1.5rem; // 置中 & 和下面文字留點距離\n    // 可選：如果想加邊框\n    // border: 3px solid #eee;\n  }\n}\n/* CPA 年份按鈕 */\n.nav-pills .nav-link {\n  border: 1px solid #e5e5e5;\n  background: #fff;\n  color: #333 !important;\n  margin-right: 6px;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .nav-link:hover {\n  background: #0d6efd !important;\n  color: #fff !important;\n  border-color: #0d6efd !important;\n}\n\n/* ================================\n   HOME REELS SECTION\n================================ */\n\n.home-reels-section {\n    padding: 70px 0 90px;\n    background: #f8f9fc;\n\n    .home-reels-header {\n        text-align: center;\n        margin-bottom: 40px;\n\n        h2 {\n            font-size: 32px;\n            font-weight: 700;\n            color: #152046;\n            margin-bottom: 12px;\n        }\n\n        p {\n            font-size: 16px;\n            color: #666;\n            margin: 0;\n        }\n    }\n\n    .home-reels-grid {\n        display: grid;\n        grid-template-columns: repeat(4, minmax(0, 1fr));\n        gap: 24px;\n        max-width: 1150px;\n        margin: 0 auto;\n    }\n\n    .home-reels-item {\n        min-width: 0;\n        overflow: hidden;\n    }\n\n    .home-reels-video {\n        position: relative;\n        width: 100%;\n        aspect-ratio: 9 / 16;\n        background: #000;\n        border-radius: 14px;\n        overflow: hidden;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n\n        iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            border: none;\n        }\n    }\n\n    .home-reels-title {\n        font-size: 15px;\n        font-weight: 600;\n        text-align: center;\n        color: #152046;\n        margin-top: 15px;\n        line-height: 1.5;\n    }\n}\n\n\n/* ================================\n   TABLET\n================================ */\n\n@media (max-width: 991px) {\n\n    .home-reels-section {\n        padding: 55px 0 70px;\n\n        .home-reels-grid {\n            grid-template-columns: repeat(2, minmax(0, 1fr));\n            gap: 20px;\n            max-width: 650px;\n        }\n\n        .home-reels-header h2 {\n            font-size: 28px;\n        }\n    }\n\n}\n\n\n/* ================================\n   MOBILE\n================================ */\n\n@media (max-width: 576px) {\n\n    .home-reels-section {\n        padding: 40px 0 55px;\n\n        .home-reels-header {\n            margin-bottom: 25px;\n\n            h2 {\n                font-size: 24px;\n            }\n\n            p {\n                font-size: 14px;\n            }\n        }\n\n        .home-reels-grid {\n            grid-template-columns: repeat(2, minmax(0, 1fr));\n            gap: 12px;\n        }\n\n        .home-reels-video {\n            border-radius: 10px;\n        }\n\n        .home-reels-title {\n            font-size: 13px;\n            margin-top: 10px;\n        }\n    }\n\n}\n\n\n/* ================================\n   EXTRA SMALL MOBILE\n================================ */\n\n@media (max-width: 360px) {\n\n    .home-reels-section {\n\n        .home-reels-grid {\n            grid-template-columns: 1fr;\n            max-width: 260px;\n        }\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
